import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Personel } from 'src/app/models/Personel';
import { NotifymodalComponent } from 'src/app/notifymodal/notifymodal.component';
import { PersonelService } from 'src/app/services/personel.service';


@Component({
  selector: 'app-update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.css']
})
export class UpdateModalComponent implements OnInit {

  public updateForm = new FormGroup({
    tc: new FormControl(''),
    sgk: new FormControl(''),
    name: new FormControl(''),
    surname: new FormControl(''),
    company: new FormControl(''),
    email: new FormControl(''),
  });

  public isRegister:boolean;
  public textButton:string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UpdateModalComponent>,
    public personelService:PersonelService,
    public dialog:MatDialog,
    ) { 
     
     // console.log(this.data.user.TcNumber);

    }

  ngOnInit(): void {

    this.updateForm.controls["tc"].setValidators([Validators.minLength(11), Validators.maxLength(11),Validators.pattern("^[0-9]*$")]);
    this.updateForm.controls["sgk"].setValidators([Validators.minLength(11), Validators.maxLength(11),Validators.pattern("^[0-9]*$")]);

    if(this.data.user){
      //console.log("personel:\n"+JSON.stringify(this.data.user));
      
      this.isRegister = false;

      this.textButton="GÜNCELLE";

      this.updateForm.setValue({
        tc:this.data.user.TcNumber,
        sgk:this.data.user.SgkNumber,
        name: this.data.user.Name,
        surname: this.data.user.Surname,
        company: this.data.user.CompanyName,
        email: this.data.user.Email,
      });
    }else if(!this.data.user){
      this.isRegister = true;
      this.textButton="EKLE";
      //console.log("user yok");
    }



    
  }


  updateUser() {

    if(this.isRegister){

      let userObj = {
        Name:this.updateForm.value.name,
        Surname:this.updateForm.value.surname,
        Email:this.updateForm.value.email,
        Password:this.updateForm.value.sgk,
        ConfirmPassword:this.updateForm.value.sgk,
        SgkNumber:this.updateForm.value.sgk,
        TcNumber:this.updateForm.value.tc,
        CompanyName:this.updateForm.value.company,
        UserType:2,
      };

      this.personelService.registerUser(userObj).subscribe(res => {
        //console.log(res);
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess:true, 
            text:"Kullanıcı ekleme başarılı.",
            subject:"Kullanıcı Ekleme"
          }
        });
      },
      error => {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess:false, 
            text: error.error.error,
            subject:"Kullanıcı Ekleme"
          }
        });
      
      });

    }else{
      let userObj = {
        UserId:this.data.user.Id,
        Name:this.updateForm.value.name,
        Surname:this.updateForm.value.surname,
        Email:this.updateForm.value.email,
        SgkNumber:this.updateForm.value.sgk,
        TcNumber:this.updateForm.value.tc,
        CompanyName:this.updateForm.value.company,
      };
  
      //console.log(JSON.stringify(userObj));
  
  
      this.personelService.updateUser(userObj).subscribe(res => {
        //console.log(res);
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess:true, 
            text:"Kullanıcı güncelleme başarılı.",
            subject:"Kullanıcı Güncelleme"
          }
        });
      },
      error => {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess:false, 
            text: error.error.error,
            subject:"Kullanıcı Güncelleme"
          }
        });
      });
    }

    this.dialogRef.close();
  }


  get tc() { return this.updateForm.get('tc'); }
  get sgk() { return this.updateForm.get('sgk'); }
  get name() { return this.updateForm.get('name'); }
  get surname() { return this.updateForm.get('surname'); }
  get company() { return this.updateForm.get('company'); }
  get email() { return this.updateForm.get('email'); }


}
